var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmitTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55719 5.55719C8.00654 3.10784 11.5723 2 16 2C20.4277 2 23.9935 3.10784 26.4428 5.55719C28.8922 8.00654 30 11.5723 30 16C30 20.4277 28.8922 23.9935 26.4428 26.4428C23.9935 28.8922 20.4277 30 16 30C11.5723 30 8.00654 28.8922 5.55719 26.4428C3.10784 23.9935 2 20.4277 2 16C2 11.5723 3.10784 8.00654 5.55719 5.55719ZM14.6667 17.3333V10.6667C14.6667 9.93029 15.2636 9.33333 16 9.33333C16.7364 9.33333 17.3333 9.93029 17.3333 10.6667V17.3333C17.3333 18.0697 16.7364 18.6667 16 18.6667C15.2636 18.6667 14.6667 18.0697 14.6667 17.3333ZM17.6667 21.6667C17.6667 22.5871 16.9205 23.3333 16 23.3333C15.0795 23.3333 14.3333 22.5871 14.3333 21.6667C14.3333 20.7462 15.0795 20 16 20C16.9205 20 17.6667 20.7462 17.6667 21.6667Z",
    fill: "#FF8000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitTop);
export default __webpack_public_path__ + "static/media/submit-top.c5e246284defecfd0e7cbba9265f0887.svg";
export { ForwardRef as ReactComponent };